module.exports = __webpack_public_path__ + "static/media/newCloud.60139498.svg";